/* eslint-disable */
import {
  AttachMoney,
  Toys,
  Archive,
  AccountBalanceWalletSharp,
  AddIcCall
} from "@material-ui/icons";
import ContactsIcon from "@material-ui/icons/Contacts";
import EventNoteIcon from "@material-ui/icons/EventNote";
import LoyaltyIcon from "@material-ui/icons/Loyalty";
import BlurCircularIcon from "@material-ui/icons/BlurCircular";

import ClassOutlinedIcon from "@material-ui/icons/ClassOutlined";
import PublicIcon from "@material-ui/icons/Public";
import SubscriptionsIcon from "@material-ui/icons/Subscriptions";
import NotificationImportantIcon from "@material-ui/icons/NotificationImportant";
import { attributeListUrl } from "@saleor/attributes/urls";
import { WindowTitle } from "@saleor/components/WindowTitle";
import { cornermarkListUrl } from "@saleor/cornermarks/urls";
import { countrieListPath } from "@saleor/countries/urls";
import { currencyrateListUrl } from "@saleor/currencyrate/urls";
import { recommendPopupUrl } from "@saleor/recommend/urls";
import useNavigator from "@saleor/hooks/useNavigator";
import useUser from "@saleor/hooks/useUser";
import { hotsearchListUrl } from "@saleor/hotsearch/urls";
import { PopipUrl } from "@saleor/popup/urls";
import Attributes from "@saleor/icons/Attributes";
import Navigation from "@saleor/icons/Navigation";
import Pages from "@saleor/icons/Pages";
import PermissionGroups from "@saleor/icons/PermissionGroups";
import Plugins from "@saleor/icons/Plugins";
import ProductTypes from "@saleor/icons/ProductTypes";
import ShippingMethods from "@saleor/icons/ShippingMethods";
import SiteSettings from "@saleor/icons/SiteSettings";
import LanguageIcon from "@material-ui/icons/Language";
import StaffMembers from "@saleor/icons/StaffMembers";
import Taxes from "@saleor/icons/Taxes";
import Warehouses from "@saleor/icons/Warehouses";
import { sectionNames } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { menuListUrl } from "@saleor/navigation/urls";
import { pageListUrl } from "@saleor/pages/urls";
import { permissionGroupListUrl } from "@saleor/permissionGroups/urls";
import { permissionSiteDetailsUrl } from "@saleor/permissionSite/urls";
import { pluginListPaymentUrl, pluginListUrl } from "@saleor/plugins/urls";
import { productTypeListUrl } from "@saleor/productTypes/urls";
import { rotaryListPath } from "@saleor/rotary/urls";
import { shippingZonesListUrl } from "@saleor/shipping/urls";
import { siteSettingsUrl } from "@saleor/siteSettings/urls";
import { siteLanguageListUrl } from "@saleor/siteLanguages/urls";
import { staffListUrl } from "@saleor/staff/urls";
import { subscriberListUrl } from "@saleor/subscribers/urls";
import { taxSection } from "@saleor/taxes/urls";
import { PermissionEnum } from "@saleor/types/globalTypes";
import { warehouseSection } from "@saleor/warehouses/urls";
import { producttagsListUrl } from "@saleor/producttags/urls";
import { emailTemplateSection } from "@saleor/emailTemplate/urls";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import LibraryAddSharpIcon from "@material-ui/icons/LibraryAddSharp";

import React from "react";
import { IntlShape, useIntl } from "react-intl";

import ConfigurationPage, { MenuSection } from "./ConfigurationPage";
import { pageheaderListUrl } from "@saleor/pageheaders/urls";
// import { registersListUrl } from "@saleor/register/urls";
import { specialOfferUrl } from "@saleor/specialOffer/urls";
import { comboListUrl } from "@saleor/combos/urls";
import { soldoutCustomPageListUrl } from "@saleor/soldoutcustompage/urls";
import { checkoutAddUrl } from "@saleor/checkoutAdd/urls";
import { productActivationSettingUrl } from "@saleor/productActivationSetting/urls";
import { ProductLensTypeListUrl } from "@saleor/productLensType/urls";

export function createConfigurationMenu(intl: IntlShape): MenuSection[] {
  return [
    {
      label: intl.formatMessage({
        defaultMessage: "Attributes and Product Types"
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            defaultMessage: "Determine attributes used to create product types",
            id: "configurationMenuAttributes"
          }),
          icon: <Attributes fontSize="inherit" viewBox="0 0 44 44" />,
          permission: PermissionEnum.MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES,
          title: intl.formatMessage(sectionNames.attributes),
          url: attributeListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Define types of products you sell",
            id: "configurationMenuProductTypes"
          }),
          icon: <ProductTypes fontSize="inherit" viewBox="0 0 44 44" />,
          permission: PermissionEnum.MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES,
          title: intl.formatMessage(sectionNames.productTypes),
          url: productTypeListUrl()
        }
      ]
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Product Settings"
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            defaultMessage: "Manage corner marks used in product variants",
            id: "configurationMenuCornerMarks"
          }),
          icon: <ClassOutlinedIcon fontSize="inherit" viewBox="0 0 22 22" />,
          permission: PermissionEnum.MANAGE_CORNERMARK,
          title: intl.formatMessage(sectionNames.cornermarks),
          url: cornermarkListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage hot words under the search bar",
            id: "configurationMenuHotsearch"
          }),
          icon: <Archive fontSize="inherit" viewBox="0 0 22 22" />,
          permission: PermissionEnum.MANAGE_HOTSEARCH,
          title: intl.formatMessage(sectionNames.hotsearch),
          url: hotsearchListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage the product tags",
            id: "configurationproducttags"
          }),
          icon: <LoyaltyIcon fontSize="inherit" viewBox="0 0 24 24" />,
          permission: PermissionEnum.MANAGE_PRODUCTTAGS,
          title: intl.formatMessage(sectionNames.producttags),
          url: producttagsListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage the soldoutcustompage",
            id: "configurationsoldoutcustompage"
          }),
          icon: <EventNoteIcon fontSize="inherit" viewBox="0 0 24 24" />,
          permission: PermissionEnum.MANAGE_PAGES,
          title: intl.formatMessage(sectionNames.soldoutcustompage),
          url: soldoutCustomPageListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage the product Lens Type",
            id: "configurationproductlenstype"
          }),
          icon: <BlurCircularIcon fontSize="inherit" viewBox="0 0 24 24" />,
          permission: PermissionEnum.MANAGE_PRODUCTLENSTYPE,
          title: intl.formatMessage(sectionNames.productLensType),
          url: ProductLensTypeListUrl()
        }
      ]
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Finance Settings"
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            defaultMessage: "Manage how your store charges tax",
            id: "configurationMenuTaxes"
          }),
          icon: <Taxes fontSize="inherit" viewBox="0 0 44 44" />,
          permission: PermissionEnum.MANAGE_SETTINGS,
          title: intl.formatMessage(sectionNames.taxes),
          url: taxSection
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage how your currency conversion",
            id: "configurationMenuRates"
          }),
          icon: <AttachMoney fontSize="inherit" viewBox="0 0 22 22" />,
          permission: PermissionEnum.MANAGE_CURRENCYRATE,
          title: intl.formatMessage(sectionNames.currencyrates),
          url: currencyrateListUrl()
        }
      ]
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Staff Settings"
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            defaultMessage: "Manage your employees and their permissions",
            id: "configurationMenuStaff"
          }),
          icon: <StaffMembers fontSize="inherit" viewBox="0 0 44 44" />,
          permission: PermissionEnum.MANAGE_STAFF,
          title: intl.formatMessage(sectionNames.staff),
          url: staffListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage:
              "Manage your permission groups and their permissions",
            id: "configurationMenuPermissionGroups"
          }),
          icon: <PermissionGroups fontSize="inherit" viewBox="0 0 44 44" />,
          permission: PermissionEnum.MANAGE_STAFF,
          title: intl.formatMessage(sectionNames.permissionGroups),
          url: permissionGroupListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage your shop staff",
            id: "configurationMenuPermissionSite"
          }),
          icon: <ContactsIcon fontSize="inherit" viewBox="0 0 22 22" />,
          permission: PermissionEnum.MANAGE_STAFF,
          title: intl.formatMessage(sectionNames.permissionSite),
          url: permissionSiteDetailsUrl()
        }
      ]
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Shipping Settings"
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            defaultMessage:
              "Manage your Countries and States that provide services",
            id: "configurationMenuCountries"
          }),
          icon: <PublicIcon fontSize="inherit" viewBox="0 0 24 24" />,
          permission: PermissionEnum.MANAGE_COUNTRY,
          title: intl.formatMessage(sectionNames.countries),
          url: countrieListPath
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage how you ship out orders",
            id: "configurationMenuShipping"
          }),
          icon: <ShippingMethods fontSize="inherit" viewBox="0 0 44 44" />,
          permission: PermissionEnum.MANAGE_SHIPPING,
          title: intl.formatMessage(sectionNames.shipping),
          url: shippingZonesListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage and update your warehouse information",
            id: "configurationMenuWarehouses"
          }),
          icon: <Warehouses fontSize="inherit" viewBox="0 0 44 44" />,
          permission: PermissionEnum.MANAGE_WAREHOUSE,
          title: intl.formatMessage(sectionNames.warehouses),
          url: warehouseSection
        }
      ]
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Marketing Settings"
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            defaultMessage: "Manage the big rotary",
            id: "configurationRotary"
          }),
          icon: <Toys fontSize="inherit" viewBox="0 0 24 24" />,
          permission: PermissionEnum.MANAGE_ROTARY,
          title: intl.formatMessage(sectionNames.rotary),
          url: rotaryListPath
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage the login popup",
            id: "configurationpopup"
          }),
          icon: (
            <AccountBalanceWalletSharp fontSize="inherit" viewBox="0 0 24 24" />
          ),
          permission: PermissionEnum.MANAGE_POPUP,
          title: intl.formatMessage(sectionNames.loginpopup),
          url: PopipUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage the recommend popup",
            id: "configurationRecommendPopup"
          }),
          icon: <AddIcCall fontSize="inherit" viewBox="0 0 24 24" />,
          permission: PermissionEnum.MANAGE_POPUP,
          title: intl.formatMessage(sectionNames.recommendPopup),
          url: recommendPopupUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage the Special Offer",
            id: "configurationSpecialOffer"
          }),
          icon: <AddShoppingCartIcon fontSize="inherit" viewBox="0 0 24 24" />,
          permission: PermissionEnum.MANAGE_REDEMPTIONS,
          title: intl.formatMessage(sectionNames.specialOffer),
          url: specialOfferUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage the Product Sets",
            id: "configurationCombo"
          }),
          icon: <ViewColumnIcon fontSize="inherit" viewBox="0 0 24 24" />,
          permission: PermissionEnum.MANAGE_COMBOS,
          title: intl.formatMessage(sectionNames.combo),
          url: comboListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage the Product Activation Setting",
            id: "configurationProductActivationSetting"
          }),
          icon: <LibraryAddSharpIcon fontSize="inherit" viewBox="0 0 24 24" />,
          permission: PermissionEnum.MANAGE_PRODUCTACTIVATION,
          title: intl.formatMessage(sectionNames.productActivationSetting),
          url: productActivationSettingUrl()
        }
      ]
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Miscellaneous"
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            defaultMessage: "Define how users can navigate through your store",
            id: "configurationMenuNavigation"
          }),
          icon: <Navigation fontSize="inherit" viewBox="0 0 44 44" />,
          permission: PermissionEnum.MANAGE_MENUS,
          title: intl.formatMessage(sectionNames.navigation),
          url: menuListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "View and update your site settings",
            id: "configurationMenuSiteSettings"
          }),
          icon: <SiteSettings fontSize="inherit" viewBox="0 0 44 44" />,
          permission: PermissionEnum.MANAGE_SETTINGS,
          title: intl.formatMessage(sectionNames.siteSettings),
          url: siteSettingsUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "View and update site languages",
            id: "configurationMenuSiteLanguages"
          }),
          icon: <LanguageIcon fontSize="inherit" viewBox="0 0 24 24" />,
          permission: PermissionEnum.MANAGE_SETTINGS,
          title: intl.formatMessage(sectionNames.siteLanguages),
          url: siteLanguageListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage and add additional pages",
            id: "configurationMenuPages"
          }),
          icon: <Pages fontSize="inherit" viewBox="0 0 44 44" />,
          permission: PermissionEnum.MANAGE_PAGES,
          title: intl.formatMessage(sectionNames.pages),
          url: pageListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage and add new page headers",
            id: "configurationMenuPageHeaders"
          }),
          icon: (
            <NotificationImportantIcon fontSize="inherit" viewBox="0 0 22 22" />
          ),
          permission: PermissionEnum.MANAGE_PAGES,
          title: intl.formatMessage(sectionNames.pageheaders),
          url: pageheaderListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "View and update your plugins and their settings.",
            id: "configurationPluginsPages"
          }),
          icon: (
            <Plugins
              fontSize="inherit"
              viewBox="-8 -5 44 44"
              preserveAspectRatio="xMinYMin meet"
            />
          ),
          permission: PermissionEnum.MANAGE_PLUGINS,
          title: intl.formatMessage(sectionNames.plugins),
          url: pluginListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "View and update your payment settings.",
            id: "configurationPluginsPages"
          }),
          icon: (
            <Plugins
              fontSize="inherit"
              viewBox="-8 -5 44 44"
              preserveAspectRatio="xMinYMin meet"
            />
          ),
          permission: PermissionEnum.MANAGE_PAYMENT,
          title: intl.formatMessage(sectionNames.payments),
          url: pluginListPaymentUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Manage email newsletter subscribers",
            id: "configurationMenuSubscribers"
          }),
          icon: <SubscriptionsIcon fontSize="inherit" viewBox="0 0 22 22" />,
          permission: PermissionEnum.MANAGE_SUBSCRIPTION,
          title: intl.formatMessage(sectionNames.subscribers),
          url: subscriberListUrl()
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Managing Mail Templates",
            id: "Managing Mail Templates"
          }),
          icon: <ShippingMethods fontSize="inherit" viewBox="0 0 44 44" />,
          permission: PermissionEnum.MANAGE_PLUGINS,
          title: "Email Template",
          url: emailTemplateSection
        },
        {
          description: intl.formatMessage({
            defaultMessage: "Checkout Pop up ads or products",
            id: "Managing Checkout Add"
          }),
          icon: <AddShoppingCartIcon fontSize="inherit" viewBox="0 0 24 24" />,
          permission: PermissionEnum.MANAGE_PLUGINS,
          title: "Checkout Add",
          url: checkoutAddUrl()
        }
      ]
    }
  ];
}

export const configurationMenuUrl = "/configuration/";

export const ConfigurationSection: React.FC = () => {
  const navigate = useNavigator();
  const user = useUser();
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.configuration)} />
      <ConfigurationPage
        menu={createConfigurationMenu(intl)}
        user={maybe(() => user.user)}
        onSectionClick={navigate}
      />
    </>
  );
};
export default ConfigurationSection;
